import React from 'react';

// Custom CSS for the button's peculiar effect
const buttonStyles = `
  .custom-button { 
    position: relative;
    overflow: hidden;
    background: linear-gradient(145deg, #6a11cb, #2575fc); /* Peculiar gradient */
    border: none;
    outline: none;
    color: white;
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* Initial shadow */
    border-radius: 9999px; /* Fully rounded */
    padding: 1rem 2.5rem; /* Ample padding */
    font-size: 1.25rem; /* Larger text */
    letter-spacing: 0.05em; /* Spaced out letters */
    /* --- Centering Properties --- */
    display: block; /* Make the button a block-level element */
    margin: 20px auto 40px auto;
  }

  .custom-button:hover {
    transform: translateY(-3px); /* Lift effect on hover */
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4); /* Enhanced shadow on hover */
    background: linear-gradient(145deg, #2575fc, #6a11cb); /* Inverted gradient on hover */
  }

  .custom-button:active {
    transform: translateY(0); /* Press effect on click */
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2); /* Reduced shadow on click */
  }

  /* Peculiar border effect using pseudo-elements */
  .custom-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(0);
    opacity: 0;
    transition: all 0.4s ease-in-out;
    z-index: 1;
  }

  .custom-button:hover::before {
    transform: scale(1);
    opacity: 1;
  }

  /* Ensure text is above pseudo-element */
  .custom-button span {
    position: relative;
    z-index: 2;
  }
`;


/**
 * A custom styled button component.
 * It accepts a click handler and content to display.
 *
 * @param {object} props - Component props.
 * @param {function} props.onClick - The function to call when the button is clicked.
 * @param {React.ReactNode} props.children - The content to display inside the button (e.g., text, icons).
 * @param {string} [props.className=""] - Additional CSS classes to apply to the button.
 */
function CustomButton({ onClick, children, className = "" }) {
  
  
  return (
    // Keep w-full on the div to ensure it spans the full width of its parent
    <div className="my-8 w-full"> 
      {/* Embed the custom styles */}
      <style>{buttonStyles}</style>
      <button
        onClick={onClick}
        className={`custom-button ${className}`} /* Use dynamic class name */
      >
        <span>{children}</span> {/* Render children here */}
      </button>
    </div>
  );
}

export default CustomButton;
